/*
 * @Author: syyoon@yongtrim.com 
 * @Date: 2018-09-11 23:28:13 
 * @Last Modified by: syyoon@yongtrim.com
 * @Last Modified time: 2018-09-26 02:15:45
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ENV } from '../env/env';
import { TransService } from './trans.service';

@Injectable()
export class ReportService {

  private url = `${ENV.SERVER_URL}/${ENV.API_PATH}/reports`;


  constructor(
    private transService: TransService,
    private http: HttpClient) {
  }

  createReport(data) {
    return this.http.post(`${this.url}?lang=${this.transService.lang}`, data);
  }

  getReports(page: number, limit: number, type?: string) {
    return this.http.get(`${this.url}?page=${page}&limit=${limit}&type=${type || ''}&lang=${this.transService.lang}`);
  }

}



// WEBPACK FOOTER //
// ./src/services/report.service.ts